export const CARE_PROVIDER_PRIORITY_LANGUAGES = ["DE", "FR", "IT", "EN"]
